var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteractionTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75,12.47412V8.5a2.625,2.625,0,0,0-5.25,0v5.59827a2.69224,2.69224,0,0,0-3.6004,4l.00317.00415.00458.00451L9.00317,22H19V14.136ZM17,20H9.791S6.571,17.07275,6.23022,16.76221a.95.95,0,1,1,1.27961-1.40454C7.76947,15.59424,9.47632,17,9.47632,17l.77368-.4V8.5A.875.875,0,0,1,12,8.5v5.52539l5,1.57324ZM5.20612,10.04883a6.12506,6.12506,0,1,1,11.83776,0l-1.89709-.65674a4.12508,4.12508,0,1,0-8.04358,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionTouch);
export default __webpack_public_path__ + "static/media/Interaction-touch.2f57f2bf.svg";
export { ForwardRef as ReactComponent };